var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-select',{attrs:{"options":_vm.options,"label":"value","multiple":_vm.multiple,"disabled":_vm.disabled},on:{"blur":_vm.blur,"click":_vm.click},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_c('template',{slot:"no-options"},[_vm._v(" Нет совпадений ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }